<template>
  <transition name="modal-fade">
    <div class="tw-modalbg tw-fixed tw-z-100 tw-inset-0 tw-flex tw-items-center tw-justify-center">
      <div :class="['tw-bg-white tw-shadow-2xl tw-max-h-screen tw-overflow-auto tw-rounded-3xl ', modalWidth]">
        <header class="tw-py-4 tw-px-8 tw-flex tw-relative tw-bg-black tw-text-white tw-font-black tw-justify-between" v-if="props.hasHeader">
          <slot name="header">
            
          </slot>
          <button
            type="button"
            class="tw-text-4xl"
            @click="handleClose"
          >
            &times;
          </button>
        </header>

        <section class="tw-py-8 tw-px-8">
          <slot name="body">
          </slot>
         </section>

        <footer>
          <slot name="footer">
            
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  const props = defineProps({
    hasHeader: Boolean,
    hasAccept: Boolean,
    modalSize: String,
  })

  const emit = defineEmits(['emitClose', 'emitAccept'])

  const handleClose = (event: Event) => {
    emit('emitClose', event)
  }

  const handleAccept = (event: Event) => {
    emit('emitAccept', event)
  }
 
  const modalWidth = computed(() => {
    let width = "tw-w-256";
    if (typeof(props.modalSize) != undefined) {
      if (props.modalSize == "large") {
        width = 'tw-w-384'
      }
    }

    return width;
  })
</script>

<style scoped>
  .tw-modalbg {
    background-color: rgba(0, 0, 0, 0.3);
  }

  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease;
  }
</style>